;(function() {
"use strict";

angular.module('kauffman-press-frontend', [
  'kauffman-press-frontend.directives',
])
  .factory('SelectedFeatures', SelectedFeatures)
  .factory('MYSW_DOMAIN', () => {
    let hostname = window.location.hostname;
    let domain = 'mysw.com';
    if (hostname !== 'localhost') {
      domain = hostname.split('.').slice(-2).join('.');
    }
    return domain;
  })
  .service('globalState', globalState)
  .constant('PRESS_SITE_ID', 1)
  .constant('SELECTION_LIMIT', 1)
  .constant('EVENTS', {
    location_selected: 'location_selected',
  });

function SelectedFeatures() {
  /**
   * @class SelectedFeatures
   *
   * @classdesc
   * Used to manage a list of selected map features keyed by their "id" property
   *
   * Initial implementation extended Map, but Babel has limitations around subclassing built-in
   * classes: https://babeljs.io/docs/en/caveats that caused it to not work in IE11
   */
  class SelectedFeatures {
    constructor() {
      this._map = new Map();
    }

    get size() {
      return this._map.size;
    }

    has(value) {
      return !!value && this._map.has(value.id);
    }

    isFirst(value) {
      const [first] = this.values();
      return first && first.id === value.id;
    }

    get(value) {
      return value && this._map.get(value.id);
    }

    add(value) {
      return value ? this._map.set(value.id, value) : this._map;
    }

    delete(value) {
      return this.has(value) && this._map.delete(value.id);
    }

    // Iterator symbols and methods that return them are not supported in IE11
    values() {
      const array = [];
      this._map.forEach((value) => { array.push(value); });
      return array;
    }

    // Iterator symbols and methods that return them are not supported in IE11
    keys() {
      const array = [];
      this._map.forEach((value, key) => { array.push(key); });
      return array;
    }
  }

  const methodsToShadow = ['clear'];
  methodsToShadow.forEach((method) => {
    SelectedFeatures.prototype[method] = function(...args) {
      return Map.prototype[method].apply(this._map, args);
    };
  });

  return SelectedFeatures;
}

globalState.$inject = ['$q', 'SelectedFeatures'];
function globalState($q, SelectedFeatures) {
  class GlobalState {
    constructor() {
      this.selectedFeatures = new SelectedFeatures();
      this.selectedFeatureDesignation = null;
      this.isShowingContactDialog = false;
      this._map = null;
      this.mapReadyPromise = $q.defer();
    }

    get map() {
      return this._map;
    }

    set map(map) {
      this._map = map;
      return map.on('load', () => {
        this.mapReadyPromise.resolve(map);
        return map;
      });
    }

    mapReady() {
      return this.mapReadyPromise.promise;
    }
  }
  return new GlobalState();
}
}());
